import { createFileRoute, redirect } from '@tanstack/react-router'
import { bootstrapQueryOptions } from '@/features/bootstrap/api/bootstrap/queries/bootstrap-query'
import { canUseOrganizationWorkspaceTools } from '@/features/organizations/domain/organization-role'
import { requireAuthenticated } from '@/shared/lib/route-guards'
import { OrganizationAgentsPage } from '@/pages/organization/agents'
import { GTM_PRODUCT_SCOPE } from '@/shared/lib/gtm-product-scope'
import { redirectToGtmEntry } from '@/shared/lib/gtm-route-guard'

export const Route = createFileRoute('/$lang/organization/agents/')({
  beforeLoad: async ({ context, params }) => {
    if (!GTM_PRODUCT_SCOPE.legacyWorkspaceUi) {
      redirectToGtmEntry(context, params)
    }
    requireAuthenticated(context, params)
    const bootstrap = await context.queryClient.ensureQueryData(
      bootstrapQueryOptions(),
    )
    if (!canUseOrganizationWorkspaceTools(bootstrap.organization)) {
      throw redirect({
        to: '/$lang/app',
        params: { lang: params.lang },
      })
    }
  },
  component: OrganizationAgentsPage,
  staticData: { layout: 'main' },
})
